var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: (_vm.dataFrom.id ? _vm.$t("编辑") : _vm.$t("新增")) + _vm.$t("模板"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("模板名称")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      placeholder: _vm.$t("请输入") + _vm.$t("模板名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "pageType",
      label: _vm.$t("页面类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("页面类型"),
      disabled: _vm.dataFrom.id ? true : false
    },
    model: {
      value: _vm.dataFrom.pageType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "pageType", $$v);
      },
      expression: "dataFrom.pageType"
    }
  }, _vm._l(_vm.pageTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };